var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError403 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 131,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 129,
  x: 1,
  y: 1,
  stroke: "#000",
  strokeWidth: 2,
  rx: 3
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 18,
  x: 1,
  y: 1,
  stroke: "#000",
  strokeWidth: 2,
  rx: 3
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 10,
  r: 2,
  stroke: "#000",
  strokeWidth: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 10,
  r: 2,
  stroke: "#000",
  strokeWidth: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 10,
  r: 2,
  stroke: "#000",
  strokeWidth: 2
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 74,
  r: 29,
  fill: "#fff",
  stroke: "#772432",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#772432",
  strokeWidth: 2,
  d: "m59 53 42 42"
})));
export { SvgError403 as ReactComponent };
export default __webpack_public_path__ + "281a56239bc7df819c7860dd3846edde.svg";